import type { RestorePhase } from '@/beta/types/showcase';

/** Display labels for the seven restore phases. Em-dash style, sentence case
 *  to match the design spec. Used by Focus thumbs and Scrubber rail. */
export const PHASE_LABEL: Record<RestorePhase | string, string> = {
  as_received: 'As received',
  teardown: 'Teardown',
  stripped: 'Stripped',
  painted: 'Painted',
  reassembled: 'Reassembled',
  completed: 'Completed',
};

export function labelForPhase(phase: string): string {
  return PHASE_LABEL[phase] ?? phase;
}
